import { Config } from 'effect'

import { DefaultEnvironment, Environment } from '../environment.ts'

type PrefixWith<T, Prefix extends string> = {
  [K in keyof T as `${Prefix}${K & string}`]: T[K]
}

type PrefixWithPublic<T> = PrefixWith<T, 'PUBLIC_'>
type PrefixWithVite<T> = PrefixWith<T, 'VITE_PUBLIC_'>
type PrefixWithNext<T> = PrefixWith<T, 'NEXT_PUBLIC_'>

interface PrefixLessPublicEnvironment {
  readonly APP_ENV: string | undefined
  readonly SENTRY_DSN: string | undefined
  readonly SENTRY_RELEASE: string | undefined
  readonly SUPABASE_URL: string | undefined
  readonly SUPABASE_ANON_KEY: string | undefined
  readonly API_ENDPOINT: string | undefined
  readonly OTEL_SERVICE_NAME: string | undefined
}

export type PublicEnvironment = PrefixWithPublic<PrefixLessPublicEnvironment>
export type VitePublicEnvironment = PrefixWithVite<PrefixLessPublicEnvironment>
export type NextPublicEnvironment =
  PrefixWithNext<PrefixLessPublicEnvironment> & {
    readonly NEXT_RUNTIME: string | undefined
  }

export const PublicEnvironmentConfig = {
  PUBLIC_APP_ENV: Config.schema(Environment, 'PUBLIC_APP_ENV').pipe(
    Config.withDefault(DefaultEnvironment),
  ),
  PUBLIC_SENTRY_DSN: Config.string('PUBLIC_SENTRY_DSN'),
  PUBLIC_SENTRY_RELEASE: Config.string('PUBLIC_SENTRY_RELEASE').pipe(
    Config.withDefault(''),
  ),
  PUBLIC_SUPABASE_URL: Config.nonEmptyString('PUBLIC_SUPABASE_URL'),
  PUBLIC_SUPABASE_ANON_KEY: Config.nonEmptyString('PUBLIC_SUPABASE_ANON_KEY'),
  PUBLIC_API_ENDPOINT: Config.string('PUBLIC_API_ENDPOINT'),
  PUBLIC_OTEL_SERVICE_NAME: Config.string('PUBLIC_OTEL_SERVICE_NAME').pipe(
    Config.withDefault('viziertronic-web'),
  ),
} satisfies Record<keyof PublicEnvironment, Config.Config<unknown>>
